





























































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class SpinningCoin extends Vue {
  @Prop() readonly logo?: string;
}
